"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var parseCMSRichText_1 = __importDefault(require("./parseCMSRichText"));

var RenderCMSRichText = function RenderCMSRichText(_ref) {
  var markdown = _ref.markdown;
  return react_1.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, parseCMSRichText_1.default)(markdown)
    }
  });
};

exports.default = RenderCMSRichText;